












import { defineComponent } from '@vue/composition-api';

// import { session } from '@utils/storage';
import Layout from '@/components/Layout/index.vue';

export default defineComponent({
  components: {
    Layout,
  },
  setup() {
    // session.set(
    //   'user-infor',
    //   '{"workEmail":"1293949902@qq.com","token":"eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiIyNWNjNmI3YS05NGE3LTQ5ZjgtYWM5NS0wNDk5ZjIxMWQwZTgiLCJpYXQiOjE3MzI3NTg3MTksInN1YiI6IntcbiAgXCJ1c2VySWRcIiA6IFwiMTU4ODA5NDA5OTk4OTE0NzY1MFwiLFxuICBcIm5hbWVcIiA6IFwi5YiY5pmT5pWPXCIsXG4gIFwid29ya0VtYWlsXCIgOiBcIjEyOTM5NDk5MDJAcXEuY29tXCIsXG4gIFwicm9sZUNvZGVcIiA6IFwib3BlcmF0b3JcIixcbiAgXCJjb21wYW55SWRcIiA6IFwiMTU4OTgyNjM2OTc1NTEzMTkwNlwiLFxuICBcImNvbXBhbnlOYW1lXCIgOiBcIuS-m-W6lOWVhuaWsDEwMVwiLFxuICBcImNvbXBhbnlUeXBlXCIgOiAxXG59IiwiZXhwIjoxNzMyNzY1OTE5fQ.1OkdWgPAbX7rRwwfI93dLaSJCVUWjjD2Vv4nkPl_cA8","isCore":false,"supplierCertId":"51142329765987177D","supplierId":"1589826369755131906","supplierName":"供应商新101","name":"刘晓敏"}',
    //   1732765919222,
    // );
  },
});
